<div class="login-container uk-flex uk-flex-center uk-flex-middle">
  <div class="uk-section">
    <div class="uk-container">
      <img src="assets/images/deck_RGB.svg" alt="Dealflow logo" />

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="uk-margin-small-top">
          <label>
            <ng-container i18n="@@Username">Username (your email)</ng-container>

            <input class="uk-input" type="text" formControlName="username" />
          </label>

          <div
            [style.visibility]="username.invalid && (username.touched || formSubmitAttempt) ? 'visible' : 'hidden'"
            class="form-error error-container">
            <small *ngIf="username.hasError('required')" i18n="@@requiredYourEmailError"> Your email is required. </small>

            <small *ngIf="username.hasError('email')" i18n="@@yourEmailError"> You must provide valid email address. </small>
          </div>
        </div>

        <div class="uk-margin-small-top">
          <label>
            <ng-container i18n="@@Password">Password:</ng-container>

            <input class="uk-input" type="password" formControlName="password" />
          </label>

          <div
            [style.visibility]="password.invalid && (password.touched || formSubmitAttempt) ? 'visible' : 'hidden'"
            class="form-error error-container">
            <small *ngIf="password.hasError('required')" i18n="@@requiredPasswordError"> Your password is required. </small>
          </div>
        </div>

        <div *ngIf="otpRequired" class="otp uk-margin-small-top">
          <label>
            OTP {{ backupToken ? 'BACKUP' : otpRequired }}

            <input class="uk-input" type="text" formControlName="otpToken" />
          </label>

          <div
            [style.visibility]="otpToken.invalid && (otpToken.touched || formSubmitAttempt) ? 'visible' : 'hidden'"
            class="form-error error-container">
            <small *ngIf="otpToken.hasError('required')" i18n="@@requiredToken"> Token is required. </small>
          </div>

          <div *ngIf="!backupToken" class="uk-margin-small-top backup-token" (click)="useBackupToken()" i18n="@@useBackupToken">
            I want to use a BACKUP token.
          </div>
        </div>

        <div class="uk-margin-small-top">
          <button type="submit" class="uk-button button-primary" i18n="@@Login">Login</button>
        </div>
        <div class="uk-margin-small-top">
          <a href="{{backendUrl}}" class="uk-button button-primary">Login using Django Admin Panel</a>
        </div>
      </form>
    </div>
  </div>
</div>
